import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectAPIParams } from '../../../store/site'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Ticker from 'supporticon/components/donation-ticker'

const DonationTicker = ({
  apiParams,
  background,
  currencyFormat,
  foreground,
  format,
  includeOffline,
  label,
  labelBackground,
  labelForeground,
  page,
  speed,
  styles
}) => (
  <Ticker
    {...apiParams}
    page={page || apiParams.page}
    layout={mapLayout(format)}
    speed={speed}
    fetchAll
    format={currencyFormat}
    includeOffline={includeOffline === 'yes'}
    label={label}
    ticker={{
      background,
      foreground,
      labelBackground,
      labelForeground,
      styles
    }}
  />
)

const mapLayout = format => {
  switch (format) {
    case 'amount and donor name':
      return 'amount-name'
    case 'amount only':
      return 'amount-only'
    case 'donor name and amount':
      return 'name-amount'
    default:
      return 'name-only'
  }
}

const mapStateToProps = store => selectAPIParams(store)

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(DonationTicker)



// WEBPACK FOOTER //
// ./components/slices/DonationTicker/index.js